const CnpjClear = (number?: string) => {
  if (!number) return number;
  return number.replace("-", "").replace(/\./g, "").replace("/", "");
};

export default CnpjClear;
